import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

const UnifiedIssuanceTimeout: React.FC = () => {
  const tMd = useMarkdownTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'unified.issuanceTimeout.header.title'}
      message={tMd('unified.issuanceTimeout.header.message')}
    ></SimpleMessagePage>
  );
};

export default UnifiedIssuanceTimeout;
